import { RequireConfig } from '@common/config';
import { AppErrorBoundary } from '@common/error';
import { useScrollTopOnRouteChange } from '@common/hooks';
import { Deconnexion, RequireSession } from '@common/oauth2';
import { ConditionUtilisation, MentionsLegales, PolitiqueConfidentialite, PolitiqueCookies } from '@common/ui/legal';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { RequireCampagne } from "./guards/RequireCampagne";
import { RequireUnregisteredOrganisme } from './guards/RequireUnregisteredOrganisme';
import { BaseLayout } from './layouts/base/Base.layout';
import { StepperLayout } from './layouts/stepper/Stepper.layout';
import { ApprobationHabilitationPage } from './pages/approbation-habilitation/ApprobationHabilitationPage';
import { CampagneTerminee } from "./pages/campagne-terminee/CampagneTerminee";
import { SearchBySiren } from './pages/searchBySiren/SearchBySiren';
import { SentForm } from './pages/sent-form/SentForm';
import { RequireStep1 } from './pages/stepper/guards/RequireStep1';
import { RequireStep2 } from './pages/stepper/guards/RequireStep2';
import { RequireStep3 } from './pages/stepper/guards/RequireStep3';
import { Step1 } from './pages/stepper/step-1/Step1';
import { Step2 } from './pages/stepper/step-2/Step2';
import { Step3 } from './pages/stepper/step-3/Step3';
import { StepperPage } from './pages/stepper/StepperPage';
import { SummaryPage } from './pages/summary/SummaryPage';
import './App.css';
import {MatomoProvider} from "./analytics/MatomoProvider";

export function App() {
  useScrollTopOnRouteChange();

  return (
    <AppErrorBoundary appName="Inscription">
      <ToastContainer />
      <Routes>
        <Route element={<RequireConfig />}>
          <Route element={<MatomoProvider/>}>
            <Route element={<BaseLayout />}>
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/politique-cookies" element={<PolitiqueCookies />} />
              <Route path="/conditions-utilisation" element={<ConditionUtilisation />} />
              <Route path="/deconnexion" element={<Deconnexion />} />
              <Route path="/campagne-terminee" element={<CampagneTerminee />} />


              <Route element={<RequireCampagne />}>
                <Route element={<RequireSession />}>
                  <Route index element={<SearchBySiren />} />

                  <Route element={<RequireUnregisteredOrganisme />}>
                    <Route element={<StepperLayout />}>
                      <Route element={<StepperPage />}>
                        <Route index path="/inscription/etape-1" element={<Step1 />} />

                        <Route element={<RequireStep1 />}>
                          <Route path="/inscription/etape-2" element={<Step2 />} />
                        </Route>

                        <Route element={<RequireStep2 />}>
                          <Route path="/inscription/etape-3" element={<Step3 />} />
                        </Route>
                      </Route>

                      <Route element={<RequireStep3 />}>
                        <Route path="/recapitulatif" element={<SummaryPage />} />
                      </Route>

                      <Route path="/demande-envoyee" element={<SentForm />} />
                    </Route>
                  </Route>
                </Route>
              </Route>

              <Route path="/approbation-habilitation/:token" element={<ApprobationHabilitationPage />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </AppErrorBoundary>
  );
}